module.exports = __webpack_public_path__ + "static/media/company-profile-ad4.a8da8683.png";